/* eslint-disable prettier/prettier */
/* eslint-disable unicorn/no-lonely-if */
/**
 * @file VenueSearchcomponent
 *
 * Membership Onboarding Journey
 */

import { render } from 'lit-html';

import Modal from '../../components/Modal';
import BankCards from '../../components/BankCards';
import {
	recommendedPlanTemplate,
	upgradeablePlansTemplate,
	packagesSummaryTemplate,
	upsellBoxTemplate
} from './membership-cards-templates';
import VenueSearch from '../../components/VenueSearch';
import AddressSearch from '../../components/AddressSearch';
import { scrollToTop, getDataFromForm } from '../../utils/misc';
import attachValidation from '../../utils/form-validation';
import Request from '../../utils/request';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import dataLayer from '../../utils/data-layer';
import { getCookie } from '../../utils/cookiesManager';

class MembershipOnboarding {
	constructor() {
		this.state = {
			section: 0,
			data: {},
			availablePlans: [],
			selectedPlan: undefined,
			isAddOn: false,
			isSubmitted: false,
			lastSavedData: {}
		};
		this._modal = undefined;
		this._mainModal = undefined;
		this._submitModal = undefined;
		this._sections = [];
		this._rules = [
			{
				target: 'isExistingMember',
				values: ['No'],
				action: 'skip-venue'
			}
		];
		this._cardsInitiated = false;
		this._paymentValidation = undefined;
		this._bankCards = undefined;
		this._isRecommended = false;
		this._submitPaymentCta = undefined;
		this.addressSearchEl = undefined;
		this.registrationInformation = {}; // this is for storing all the onboarding selected values so to push it to local storage to be accessed by verkeer.co for Google Analytics.
		this.currentPath = window.location.pathname;
		this.analyticsCookie = undefined;

		this.initiateOnboarding();
		const venueSearchElement = document.querySelector('.lta-venue-search');
		if (venueSearchElement) {
			this.venueSearchEl = VenueSearch.getOrCreateInstance(venueSearchElement);
		}
	}

	// eslint-disable-next-line complexity
	initiateOnboarding() {
		const trigger = document.querySelector('.js-onboarding-trigger');
		this._modal = document.querySelector('#onboarding-modal');
		const closeModal = document.querySelector('#exit-onboarding');
		const forms = document.querySelectorAll('.lta-content--form-element');

		if (trigger !== null && this._modal !== null) {
			this.initiateOnboardingData();
			this.getAnalyticsCookie();
			this._mainModal = new Modal(this._modal, {});

			this._submitModal = new Modal(document.querySelector('#submission-loading'), { backdrop: 'static' });
			const addressSearchElement = SelectorEngine.findOne('.js-membership-onboarding-address', this._modal);

			this.addressSearchEl = AddressSearch.getInstance(addressSearchElement);
			const exitModal = new Modal(closeModal, { backdrop: 'static' });
			const closeCtas = this._modal.querySelectorAll('.js-onboarding-close');
			const continueCta = closeModal.querySelector('.js-onboarding-continue');
			const exitCta = closeModal.querySelector('.js-onboarding-exit');
			const nextSectionCtas = this._modal.querySelectorAll('.js-next-section');
			const previousCtas = this._modal.querySelectorAll('.js-onboarding-back');
			const nextPartCtas = this._modal.querySelectorAll('.js-next-part');
			const saveExitCtas = this._modal.querySelectorAll('.js-save-exit');
			const submitCta = this._modal.querySelector('.js-submit-data');
			const dismissError = this._modal.querySelector('.js-dismiss-submit-error');
			this._sections = this._modal.querySelectorAll('.lta-onboarding-container');
			this._submitPaymentCta = SelectorEngine.findOne('.js-membership-creation');
			this.modalNotShowUrl = SelectorEngine.findOne('.lta-membership-modal').getAttribute('data-url-modalNotLoad') || '';
			this.modalShowUrl = SelectorEngine.findOne('.lta-membership-modal').getAttribute('data-url-modalLoad') || '';
			const skipOnboarding = SelectorEngine.findOne('.lta-membership-modal').getAttribute('data-skip-onboarding') || '';
			this.skipOnboarding = skipOnboarding.toLowerCase() === 'true';
		
			// To handle a default useCase
			this.modalNotShowUrl = SelectorEngine.findOne('.lta-membership-modal').getAttribute('data-url-modalNotLoad') || '';
			this.modalShowUrl = SelectorEngine.findOne('.lta-membership-modal').getAttribute('data-url-modalLoad') || '';
			if (this.modalShowUrl === '') {
				if (!sessionStorage.ltaOnboardingExit && this.skipOnboarding) {
					sessionStorage.ltaOnboardingExit = true;
				} else if (!sessionStorage.ltaOnboardingExit && !this.skipOnboarding) {
					this._mainModal.show();
				}

				trigger.addEventListener('click', () => {
					this._mainModal.show();
				});
			} else {
				if (!sessionStorage.ltaOnboardingExit && this.skipOnboarding) {
					sessionStorage.ltaOnboardingExit = true;
				} // To show the Modal popup in new page 
				else if (this.currentPath === this.modalShowUrl) {
					this._mainModal.show();
				} else if (!sessionStorage.ltaOnboardingExit && !this.skipOnboarding) {
					// Redirecting to a new page and the using above if condition
					if (this.currentPath === this.modalNotShowUrl) {
						window.location.href = this.modalShowUrl;
					}
				}
				trigger.addEventListener('click', () => {
					if (this.currentPath === this.modalShowUrl) {
						this._mainModal.show();
					} else if (this.currentPath === this.modalNotShowUrl) {
						window.location.href = this.modalShowUrl;
					}
				});
			}

			this._modal.addEventListener('cards', this.updateHasCards.bind(this));

			for (const cta of closeCtas) {
				cta.addEventListener('click', () => {
					if (this._isRecommended) {
						this.exitJourney();
					} else {
						exitModal.show();
					}
				});
			}

			for (const cta of nextSectionCtas) {
				cta.addEventListener('click', () => {
					this.goToNextSection();
				});
			}

			for (const cta of previousCtas) {
				cta.addEventListener('click', () => {
					this.getPreviousPart();
				});
			}

			for (const cta of saveExitCtas) {
				cta.addEventListener('click', () => {
					cta.disabled = true;
					this.saveAndExit(cta);
				});
			}

			for (const cta of nextPartCtas) {
				cta.addEventListener('click', (event) => {
					this.goToNextPart(event);
				});
			}

			continueCta.addEventListener('click', () => {
				exitModal.hide();
			});

			exitCta.addEventListener('click', () => {
				exitModal.hide();
				this.exitJourney();
			});

			for (const form of forms) {
				form.addEventListener('change', (event) => {
					this.checkForm(event);
				});
			}

			submitCta.addEventListener('click', () => this.submitOnboarding());

			dismissError.addEventListener('click', () => {
				const errorPopup = document.querySelector('.lta-onboarding-submit--error');
				errorPopup.classList.add('u-hidden');
			});

			const finishCtas = document.querySelectorAll('.js-continue-home');
			finishCtas.forEach((button) => {
				button.addEventListener('click', (event) => {
					const url = event.currentTarget.dataset.target;
					window.location.href = url;
				});
			});
		}
	}

	getAnalyticsCookie() {
		let myCookie = getCookie('cookieprefs');
		let decodedStr = decodeURIComponent(myCookie);
		let jsonObject = JSON.parse(decodedStr);

		const perfCookie = jsonObject.perf;
		this.analyticsCookie =  perfCookie == true ? 'granted' : 'denied';
	}

	async initiateOnboardingData() {
		const url = '/api/membership/GetValuesForSavedOnboardedQuestions';
		const onboardingData = await Request.get(url).catch((error) => {
			if (error?.Error?.ErrorCode == '00' || error?.Error?.ErrorCode == '01') {
				// eslint-disable-next-line no-console
				console.error(error.Error.ErrorMessage);
				return false;
			}
		});

		if (onboardingData?.Error?.ErrorCode == '02') {
			this.state.lastSavedData = onboardingData.Response;
			this.state.lastSavedData.interest =
				this.state.lastSavedData.interest !== null
					? this.state.lastSavedData.interest
					: [];
		}
	}

	updateHasCards(event) {
		this._submitPaymentCta.disabled = !event.detail.hasCards;
	}

	exitJourney() {
		window.location.href = this.modalNotShowUrl;
		this._mainModal.hide();
		this.resetJourney();
		if (this.state.isSubmitted) {
			setTimeout(() => location.reload(), 300);
		}
	}

	async saveAndExit(cta) {
		const url = '/api/membership/PostOnboardingQuestionsSaveAndExit';

		// Add `venueDetails` if missing from data. This happens if the question was skipped
		if (this.state.lastSavedData.isExistingMember == 'No') {
			this.state.lastSavedData.venueDetails = [];
		}
		const saveExitJourney = await Request.post(url, this.state.lastSavedData).catch((error) => {
			if (error?.Error?.ErrorCode == '00' || error?.Error?.ErrorCode == '01') {
				console.error(error.Error.ErrorMessage);
				this.showError('We have had an error retrieving a membership for you');
				return false;
			}
		});

		if (saveExitJourney.statusCode == '02') {
			cta.disabled = false;
			document.querySelector('#exit-onboarding').querySelector('.js-onboarding-exit').click();
		}
	}

	async goToNextSection() {
		if(this.state.section === 3) {
			// validate address search. If the address is invalid and the section is 3, don't go to the next section.
			const validationStatus = await this.addressSearchEl.validate();
			if (validationStatus === "Invalid") return;
		}
		const currentPosition = this.state.section;
		if (currentPosition + 1 < this._sections.length) {
			this._sections.item(currentPosition).classList.add('u-hidden');
			this._sections.item(currentPosition + 1).classList.remove('u-hidden');
			this.fillSectionData(currentPosition);
			this.state.section = this.state.section + 1;
			this._modal.scrollTop = 1;
			this.screenReaderNarrationFix();
		}
	}

	fillSectionData(currentPosition) {
		if (currentPosition == 0) {
			if (this.state.lastSavedData?.creationReason !== null) {
				if (this.state.lastSavedData.creationReason.includes(' ')) {
					const creationReason = SelectorEngine.findOne(
						`input[name='creationReason'][id="${'user-role-' + this.state.lastSavedData.creationReason.toLowerCase().replace(' ', '-')
						}"]`
					);
					creationReason.click();
				} else {
					const creationReason = SelectorEngine.findOne(
						`input[name='creationReason'][id="${'user-role-' + this.state.lastSavedData.creationReason.toLowerCase()}"]`
					);
					creationReason.click();
				}
			}
		} else if (currentPosition == 1) {
			const isExistingMember = SelectorEngine.findOne(
				"input[name='isExistingMember'][value=" + this.state.lastSavedData.isExistingMember + ']'
			);
			isExistingMember.click();
		} else if (
			currentPosition == 2 &&
			!(
				this.state.lastSavedData.address.street === null &&
				this.state.lastSavedData.address.city === null &&
				this.state.lastSavedData.address.state === null &&
				this.state.lastSavedData.address.postCode === null
			)
		) {
			this.addressSearchEl.populateManualForm(this.state.lastSavedData.address);
		}
	}

	getPreviousPart() {
		const currentSection = this._sections.item(this.state.section);
		const sectionParts = currentSection.querySelectorAll('.js-lta-section-content');
		if (sectionParts.length === 1 || !sectionParts.item(0).classList.contains('u-hidden')) {
			this.goToPreviousSection();
		} else {
			this.goToPreviousPart();
		}
	}

	handleEditPackage(event) {
		event.preventDefault();
		this.goToPreviousSection();
	}

	goToPreviousSection() {
		const currentPosition = this.state.section;
		if (currentPosition - 1 >= 0) {
			this._sections.item(currentPosition).classList.add('u-hidden');
			this._sections.item(currentPosition - 1).classList.remove('u-hidden');
			this.state.section = this.state.section - 1;
			this._modal.scrollTop = 1;
			this.screenReaderNarrationFix();
		}
	}

	goToNextPart(event) {
		this.fillNextPartData();
		const clickedButton = event.target;
		if (clickedButton.dataset.rule) {
			this.handleRules(clickedButton.dataset.rule);
		} else {
			const currentPart = clickedButton.closest('.js-lta-section-content');
			const nextPart = currentPart.nextElementSibling;
			currentPart.classList.add('u-hidden');
			nextPart.classList.remove('u-hidden');
			this._modal.scrollTop = 1;
			this.screenReaderNarrationFix();
		}
	}

	fillNextPartData() {
		if (this.state.section == 1) {
			if (this.state.lastSavedData.interest !== null) {
				// TODO: This is for the interest field.
				if(this.state.lastSavedData.interest.length > 0) {
					this.state.lastSavedData.interest.forEach((interest) => {
						const creationReason = SelectorEngine.findOne(
							"input[name='interest'][value=" + interest + ']'
						);
						creationReason?.click();
					});
				} else if(typeof this.state.lastSavedData.interest === 'string') {
					const creationReason = SelectorEngine.findOne(
						"input[name='interest'][value=" + this.state.lastSavedData.interest + ']'
					);
					creationReason?.click();
				}
			}
		} else if (this.state.section == 2) {
			this.state?.lastSavedData?.venueDetails?.length > 0 &&
				this.state.lastSavedData?.venueDetails?.map((index) => {
					this._mainModal._element.querySelector('.lta-venue-search--search').classList.add('u-hidden');
					if (!this.venueSearchEl.state.venues.some((id) => id?.venueId === index.venueId)) {
						this.venueSearchEl.addVenue(index);
					}
					this._mainModal._element.querySelector('.lta-venue-search--add').classList.remove('u-hidden');
				});
		}
	}

	goToPreviousPart() {
		const currentSection = this._sections.item(this.state.section);
		const sectionParts = currentSection.querySelectorAll('.js-lta-section-content');
		let currentPart;
		for (const part of sectionParts) {
			if (!part.classList.contains('u-hidden')) {
				currentPart = part;
			}
		}
		currentPart.classList.add('u-hidden');
		currentPart.previousElementSibling.classList.remove('u-hidden');
		this._modal.scrollTop = 1;
		this.screenReaderNarrationFix();
	}

	// this is to prevent the screen reader from narrating outside the modal after changing from section
	screenReaderNarrationFix() {
		this._modal.focus();
	}

	resetJourney() {
		const currentPosition = this.state.section;
		if (currentPosition !== 0) {
			this._sections.item(currentPosition).classList.add('u-hidden');
			this._sections.item(0).classList.remove('u-hidden');
			this.state.section = 0;
		}

		for (const section of this._sections) {
			const parts = section.querySelectorAll('.js-lta-section-content');
			for (const [index, part] of parts.entries()) {
				if (index === 0) {
					part.classList.remove('u-hidden');
				} else {
					part.classList.add('u-hidden');
				}
			}
		}

		sessionStorage.ltaOnboardingExit = true;
	}

	handleRules(rule) {
		switch (rule) {
			case 'redirect':
				this.ruleRedirect();
				break;

			case 'skip-venue':
				this.ruleSkipVenue();
				break;

			default:
				break;
		}
	}

	checkForm(event) {
		const inputChanged = event.target;
		const eventDetail = event.detail;
		let formattedValue = inputChanged.value;
		let valueName = inputChanged.name;
		if(event.target.type === 'checkbox') {
			const checkedCheckboxes = SelectorEngine.find(`input[name='${valueName}']:checked`);
			formattedValue = Array.from((checkedCheckboxes || []))?.map(item => item.value);
		}
		if (eventDetail) {
			const { name, values } = event.detail;
			if (name === 'venueDetails') {
				// formattedValue = values.map((value) => ({ venueId: value.venueId, paymentType: value.paymentType }));
				formattedValue = values;
				valueName = name;
			}
			if (name === 'address') {
				formattedValue = values;
				valueName = name;
			}
		}
		this.state.data = Object.assign({}, this.state.data, { [valueName]: formattedValue });
		this.state.lastSavedData = Object.assign(
			{},
			this.state.lastSavedData,
			{ [valueName]: formattedValue },
			{ userName: '' }
		);
		const part = inputChanged.closest('.js-lta-section-content');
		const submitCta = part.querySelector('.lta-onboarding--part');
		const saveExitCta = part.querySelector('.js-save-exit');

		for (const rule of this._rules) {
			if (rule.target === valueName) {
				if (rule.values.includes(formattedValue)) {
					submitCta.dataset.rule = rule.action;
				} else {
					delete submitCta.dataset.rule;
				}
			}
		}

		if (submitCta !== null) {
			if ((eventDetail && eventDetail.values.length === 0) || (!eventDetail && !(typeof formattedValue === 'string' ? formattedValue : formattedValue?.length))) {
				submitCta.classList.add('u-hidden');
				saveExitCta?.classList.add('u-hidden');
			} else {
				submitCta.classList.remove('u-hidden');
				saveExitCta?.classList.remove('u-hidden');
			}
		}
	}

	ruleRedirect() {
		this._mainModal.hide();
		this.resetJourney();
	}

	ruleSkipVenue() {
		this.goToNextSection();
	}

	showProcessing() {
		this._submitModal.hide();
		const errorPopup = document.querySelector('.lta-onboarding-submit--processing');
		errorPopup.classList.remove('u-hidden');
		scrollToTop();
	}

	showError(title) {
		this._submitModal.hide();
		const errorPopup = document.querySelector('.lta-onboarding-submit--error');
		const popupTitle = SelectorEngine.findOne('.title', errorPopup);
		popupTitle.innerHTML = title;
		errorPopup.classList.remove('u-hidden');
		scrollToTop();
	}

	renderAutoRecommendedCards(data) {
		const recommendedCardContainerElement = SelectorEngine.findOne('.js-recommended-plan-container');
		const upgradeableCardContainerElement = SelectorEngine.findOne('.js-upgradeable-plan-container');
		const upgradeableCardAttributes = Manipulator.getDataAttributes(upgradeableCardContainerElement);

		const recommendedCardTpl = recommendedPlanTemplate(data.RecommendedPlan, this.handlePackageSelection.bind(this));
		const upgradeableCardsTpl = upgradeablePlansTemplate(
			{ cardsData: { ...upgradeableCardAttributes }, plansData: data.UpgradeablePlans },
			this.handlePackageSelection.bind(this)
		);

		render(recommendedCardTpl, recommendedCardContainerElement);
		render(upgradeableCardsTpl, upgradeableCardContainerElement);
	}

	async submitOnboarding() {
		const modalContent = document.querySelector('.lta-onboarding-container');
		const url = modalContent.dataset.url;

		// Add `venueDetails` if missing from data. This happens if the question was skipped
		if (this.state.data.isExistingMember == 'No') {
			this.state.data.venueDetails = [];
		}

		this._submitModal.show();
		this.state.data = Object.assign({}, this.state.data, { userName: '' });
		const sumbissionResponse = await Request.post(url, this.state.data).catch(() =>
			this.showError('We have had an error retrieving a membership for you')
		);

		this.state.isSubmitted = true;
		const { RecommendedPlan, UpgradeablePlans, IsRecommended } = sumbissionResponse;
		this._isRecommended = IsRecommended;
		if (RecommendedPlan && UpgradeablePlans.length > 0) {
			this.renderAutoRecommendedCards(sumbissionResponse);
			this.storeAvailablePlans(sumbissionResponse);
			// Here we are pushing the onboard selected options and recommended membership to the dataLayer so that the Google tag manager can access them.
			const formData = { 
				event: 'membership options selected', 
				analytics_storage: this.analyticsCookie, 
				...this.state.data };
			const plansForDataLayer = {
				event: 'Recommended memberships',
				RecommendedPlan: `${RecommendedPlan.NamePrefix} ${RecommendedPlan.Name}`,
				analytics_storage: this.analyticsCookie,
			};
			plansForDataLayer.RecommendedPlanAddOn = RecommendedPlan.AddOn
				? `${RecommendedPlan.AddOn.NamePrefix} ${RecommendedPlan.AddOn.Name}`
				: null;
			plansForDataLayer.UpgreadablePlans = [];
			for (const plan of UpgradeablePlans) {
				plansForDataLayer.UpgreadablePlans.push({ UpgradeablePlan: `${plan.NamePrefix} ${plan.Name}` });
			}
			dataLayer.push(formData, plansForDataLayer);
			this.registrationInformation = { ...this.registrationInformation, ...formData, ...plansForDataLayer };
			// end of pushing the values to DataLayer.
			this._submitModal.hide();
			this.goToNextSection();

			const addonInput = SelectorEngine.findOne('#recommendedPlanAddonCheckbox');
			if (addonInput !== null) {
				addonInput.addEventListener('change', (e) => this.changeMainPackageId(e));
			}

			if (sumbissionResponse.IsRecommended && addonInput !== null) {
				addonInput.checked = true;
				const eventCopy = { target: { value: addonInput.value, checked: true } };
				this.changeMainPackageId(eventCopy);
			}
		}
	}

	storeAvailablePlans(data) {
		const { RecommendedPlan, UpgradeablePlans } = data;
		this.state.availablePlans.push(RecommendedPlan);
		if (RecommendedPlan.AddOn) {
			this.state.availablePlans.push(RecommendedPlan.AddOn);
		}
		this.state.availablePlans = [...this.state.availablePlans, ...UpgradeablePlans];
	}

	changeMainPackageId(event) {
		const { value, checked } = event.target;
		const mainCta = SelectorEngine.findOne('.js-package-main');
		const { MembershipId, ContinueButtonText } = this.state.availablePlans[0];
		if (checked) {
			mainCta.dataset.package = value;
			mainCta.innerHTML = `${ContinueButtonText} (+ add-on)`;
			this.state.isAddOn = true;
		} else {
			mainCta.dataset.package = MembershipId;
			mainCta.innerHTML = ContinueButtonText;
			this.state.isAddOn = false;
		}
	}

	updatePackages(packageId) {
		this.state.selectedPlan = this.state.availablePlans.find((plan) => plan.MembershipId === packageId);

		const mebershipPaymentWrapper = SelectorEngine.findOne('.lta-membership-checkout--payments-method');
		if (this.state.selectedPlan.Price > 0) {
			if (!this._cardsInitiated) {
				this._bankCards = new BankCards('.js-membership-payments-options');
				this._cardsInitiated = true;
			}
			mebershipPaymentWrapper.classList.remove('u-hidden');
		} else {
			mebershipPaymentWrapper.classList.add('u-hidden');
		}

		const membershipTotal = SelectorEngine.findOne('.js-package-total');
		membershipTotal.innerHTML = this.state.selectedPlan.DisplayPrice;

		const packagesWrapper = SelectorEngine.findOne('.lta-membership-checkout--summary-packages');
		const packagesTemplate = packagesSummaryTemplate(
			this.state.selectedPlan,
			this.state.isAddOn,
			this.state.availablePlans,
			this.handleEditPackage.bind(this)
		);
		render(packagesTemplate, packagesWrapper);

		const upsellBox = SelectorEngine.findOne('.lta-membership-checkout--summary-add-upgrade');
		render(
			upsellBoxTemplate(this.state.selectedPlan, this.state.availablePlans, this.handleUpsellSelection.bind(this)),
			upsellBox
		);

		const freeMembershipCta = SelectorEngine.findOne('.js-free-membership-creation');
		if (this.state.selectedPlan.Price > 0) {
			this._submitPaymentCta.classList.remove('u-hidden');
			freeMembershipCta.classList.add('u-hidden');
		} else {
			this._submitPaymentCta.classList.add('u-hidden');
			freeMembershipCta.classList.remove('u-hidden');
		}
	}

	handleUpsellSelection(event) {
		const packageId = event.target.dataset.package;
		const [mainPlan] = this.state.availablePlans;
		this.state.isAddOn = mainPlan.AddOn && packageId === mainPlan.AddOn.MembershipId ? true : false;
		this.updatePackages(packageId);
	}

	handlePackageSelection(event) {
		const packageId = event.target.dataset.package;
		if (!this.state.selectedPlan) {
			this.validatePaymentForm();
		}
		this.updatePackages(packageId);

		const freeMembershipCta = SelectorEngine.findOne('.js-free-membership-creation');
		freeMembershipCta.addEventListener('click', () => {
			//after finalizing the membership we are pushing the selected plan to the dataLayer.
			// eslint-disable-next-line max-len
			const FinalizedMembershipDataLayer = {
				event: 'membership sign-up completed',
				SelectedPlan: `${this.state.selectedPlan.NamePrefix} ${this.state.selectedPlan.Name}`,
				Price: this.state.selectedPlan.DisplayPrice,
				analytics_storage: this.analyticsCookie
			};
			dataLayer.push(FinalizedMembershipDataLayer);
			this.registrationInformation = { ...this.registrationInformation, ...FinalizedMembershipDataLayer };
			localStorage.setItem('Registration-Information', JSON.stringify(this.registrationInformation));
			this.goToNextSection();
		});
		this.goToNextSection();
	}

	validatePaymentForm() {
		const paymentForm = SelectorEngine.findOne('#payment-methods-cards');
		const cardValidators = {
			validators: {
				notEmpty: {
					message: 'Please select one payment option below, or alternatively add a new payment type'
				}
			}
		};
		paymentForm.addEventListener('addCard', (event) => this.addFieldToValidation(event, cardValidators));
		this._paymentValidation = attachValidation(paymentForm, {
			CardTokenId: cardValidators
		});

		this._paymentValidation.on('core.form.valid', async () => {
			this._bankCards.showCards();
			const dataObject = getDataFromForm(paymentForm);

			if (dataObject.CardTokenId) {
				this._submitPaymentCta.disabled = true;
				const paymentRequest = await Request.post('/api/payments/pay', {
					Customer: {
						CustomerId: dataObject.CustomerId
					},
					OrderTotal: this.state.selectedPlan.Price,
					LineItems: [
						{
							ProductId: this.state.selectedPlan.SalesForceId
						}
					],
					PaymentMethod: {
						CardTokenId: dataObject.CardTokenId,
						RecurringPayment: true,
						RetainCard: true
					}
				}).catch(() => {
					this.showError('We have had an error processing your payment');
				});

				switch (paymentRequest.Status) {
					case 'SUCCEEDED':
						this.finishOnboarding();
						break;
					case 'PROCESSING':
						this.showProcessing();
						break;
					case 'REQ_AUTHORIZATION':
						const { paymentIntent, error } = await this._bankCards._stripeLTA
							.confirmCardPayment(paymentRequest.ClientSecret)
							.catch(() => {
								this.showError('We were unable to confirm your card payment.', false);
								this._submitPaymentCta.disabled = false;
							});

						if (error) {
							this._bankCards.showError(error.message, false);
							this._submitPaymentCta.disabled = false;
							const cancelPayment = await this._bankCards.captureCardPayment(error.payment_intent.id);
						} else {
							const capturePayment = await this._bankCards
								.captureCardPayment(paymentIntent.id)
								.then((response) => {
									if (response.Status) {
										this.finishOnboarding();
									} else {
										this.showError('We were unable to confirm your card payment.', false);
									}
								})
								.catch(() => {
									this.showError('We were unable to confirm your card payment.', false);
									this._submitPaymentCta.disabled = false;
								});
						}
						break;
					default:
						this.showError(paymentRequest.ErrorMessage);
						this._submitPaymentCta.disabled = false;
				}
			}
		});
	}

	addFieldToValidation(event, validators) {
		this._paymentValidation.addField('CardTokenId', validators);
	}

	finishOnboarding() {
		// after finalizing the payment for membership we are pushing the selected plan to the dataLayer. These local storage should be deleted in future when verkeer.co is able to track with dataLayer.
		// eslint-disable-next-line max-len
		const FinalizedMembershipDataLayer = {
			event: 'membership sign-up completed',
			SelectedPlan: `${this.state.selectedPlan.NamePrefix} ${this.state.selectedPlan.Name}`,
			Price: this.state.selectedPlan.DisplayPrice,
			analytics_storage: this.analyticsCookie
		};
		dataLayer.push(FinalizedMembershipDataLayer);
		this.registrationInformation = { ...this.registrationInformation, ...FinalizedMembershipDataLayer };
		localStorage.setItem('Registration-Information', JSON.stringify(this.registrationInformation));
		this.goToNextSection();
	}
}

const globalOnboarding = new MembershipOnboarding();

export default globalOnboarding;
